(function () {
    'use strict';

    angular
        .module('app.mentionDetail')
        .factory('mentionDetailService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function updateMention(mention_id, params, loader) {
                    var url_updateMention = $rootScope.apiUrl + 'mention/updateMention/' + mention_id;
                    return handleRequest(url_updateMention, 'POST', params, loader);
                }
                
                service.updateMention = updateMention;
                return service;
            }
        ]);
})();
